import moment from 'moment';
import { capitalizeFirstLetter } from './globalFunction';

export function CompLeaveApprovalCollection(getApplication, intl) {
    let approval = []
    if(getApplication.length > 0) {
        for (let i = 0; i < getApplication.length; i++) {
            const reqItemsPeriods = formatReqItemsPeriods(getApplication[i]);
            const justification = keepFirstThreeOptions(getApplication[i].application.description);

            approval.push({
                id           : `${getApplication[i].id}`,
                staffNo      : `${getApplication[i].application.employee.staff_no}`,
                employee     : `${getApplication[i].application.employee.employee_name}`,
                position     : `${getApplication[i].application.employee.position}`,
                location     : `${getApplication[i].application.employee.location.name}`,
                period       : `${reqItemsPeriods}`,
                totalHours   : `${getApplication[i].application.hours}`,
                justification   : `${justification}`,
                items   : `${getApplication[i].application.items}`,
                dataSubmitted: `${moment(getApplication[i].application.created_at).format(window.global.displayDateTimeFormat)}`,
            });
        }
    }
    return approval;
}

export function CompLeaveApprovalHistoryCollection(getApplication, intl) {
    let approval = []
    const statusIntl = 'status.';

    if(getApplication.length > 0) {
        for (let i = 0; i < getApplication.length; i++) {
            approval.push({
                id           : `${getApplication[i].id}`,
                staffNo      : `${getApplication[i].application.employee.staff_no}`,
                employee     : `${getApplication[i].application.employee.employee_name}`,
                position     : `${getApplication[i].application.employee.position}`,
                location     : `${getApplication[i].application.employee.location.name}`,
                period       : `${getApplication[i].application.period}`,
                justification   : `${getApplication[i].application.description}`,
                items   : `${getApplication[i].application.items}`,
                totalHours   : `${getApplication[i].application.hours.toFixed(1)}`,
                dateSubmitted: `${moment(getApplication[i].application.created_at).format(window.global.displayDateTimeFormat)}`,
                dateApproved : `${moment(getApplication[i].updated_at).format(window.global.displayDateTimeFormat)}`,
                status       : `${intl.formatMessage({ id: statusIntl + getApplication[i].status })}`,
            });
        }
    }
    return approval;
}

export function CompLeaveApprovalHistoryReportCollection(getApplication, intl) {
    let approval = []
    const statusIntl = 'status.';
    if(getApplication.length > 0) {
        getApplication.forEach((row) => {
            const reqItems = row.application.comp_leave_reqs.details;
            const isApproved = row.status == 2;

            reqItems.forEach((item, idx) => {
                approval.push({
                    id             : `${row.id}`,
                    staffNo        : `${row.application.employee.staff_no}`,
                    employee       : `${row.application.employee.employee_name}`,
                    position       : `${row.application.employee.position}`,
                    location       : `${row.application.employee.location.name}`,
                    department     : `${row.application.employee.department.name}`,
                    staffDuty      : `${capitalizeFirstLetter(row.application.employee.staff_duty)}`,
                    period         : `${row.application.period}`,
                    totalHours     : `${row.application.hours.toFixed(1)}`,
                    dateSubmitted  : `${moment(row.application.created_at).format(window.global.displayDateTimeFormat)}`,
                    dateApproved   : `${moment(row.updated_at).format(window.global.displayDateTimeFormat)}`,
                    status         : intl.formatMessage({ id: statusIntl + row.status }),
                    from           : `${moment(item.from).format(window.global.displayDateTimeFormat)}`,
                    to             : `${moment(item.to).format(window.global.displayDateTimeFormat)}`,
                    hours          : `${item.hours.toFixed(1)}`,
                    usedCompLeave  : `${isApproved ? item.used.toFixed(1) : '-'}`,
                    usedCashOut    : `${isApproved ? item.cash_out.toFixed(1) : '-'}`,
                    remaining      : `${isApproved ? item.remaining.toFixed(1) : '-'}`,
                    expiryDate     : `${item.expire_date}`,
                    justification  : `${item.description}`.replace(/^[\s\n\r\t]+|[\s\n\r\t]+$/g, '').replace(/\n/g, ' ').replace(/^(\s*-\s*)+/, ''),
                });
            });
        });
    }
    return approval;
}

export function fullOTHistoryCollection(getApplication, intl) {
    let approval = []
    const statusIntl = 'status.';

    if(getApplication.length > 0) {
        for (let i = 0; i < getApplication.length; i++) {
            approval.push({
                id           : `${getApplication[i].id}`,
                staffNo      : `${getApplication[i].employee.staff_no}`,
                employee     : `${getApplication[i].employee.employee_name}`,
                position     : `${getApplication[i].employee.position}`,
                location     : `${getApplication[i].employee.location.name}`,
                period       : `${getApplication[i].period}`,
                justification   : `${getApplication[i].description}`,
                items   : `${getApplication[i].items}`,
                totalHours   : `${getApplication[i].hours.toFixed(1)}`,
                dateSubmitted: `${moment(getApplication[i].created_at).format(window.global.displayDateTimeFormat)}`,
                dateApproved : `${moment(getApplication[i].updated_at).format(window.global.displayDateTimeFormat)}`,
                status       : `${intl.formatMessage({ id: statusIntl + getApplication[i].status })}`,
            });
        }
    }
    return approval;
}

export function fullOTHistoryReportCollection(getApplication, intl) {
    let approval = []
    const statusIntl = 'status.';
    if(getApplication.length > 0) {
        getApplication.forEach((row) => {
            const reqItems = row.comp_leave_reqs.details;
            const isApproved = row.status == 2;

            reqItems.forEach((item, idx) => {
                approval.push({
                    id             : `${row.id}`,
                    staffNo        : `${row.employee.staff_no}`,
                    employee       : `${row.employee.employee_name}`,
                    position       : `${row.employee.position}`,
                    location       : `${row.employee.location.name}`,
                    department     : `${row.employee.department.name}`,
                    staffDuty      : `${capitalizeFirstLetter(row.employee.staff_duty)}`,
                    period         : `${row.period}`,
                    totalHours     : `${row.hours.toFixed(1)}`,
                    dateSubmitted  : `${moment(row.created_at).format(window.global.displayDateTimeFormat)}`,
                    dateApproved   : `${moment(row.updated_at).format(window.global.displayDateTimeFormat)}`,
                    status         : intl.formatMessage({ id: statusIntl + row.status }),
                    from           : `${moment(item.from).format(window.global.displayDateTimeFormat)}`,
                    to             : `${moment(item.to).format(window.global.displayDateTimeFormat)}`,
                    hours          : `${item.hours.toFixed(1)}`,
                    usedCompLeave  : `${isApproved ? item.used.toFixed(1) : '-'}`,
                    usedCashOut    : `${isApproved ? item.cash_out.toFixed(1) : '-'}`,
                    remaining      : `${isApproved ? item.remaining.toFixed(1) : '-'}`,
                    expiryDate     : `${item.expire_date}`,
                    justification  : `${item.description}`.replace(/^[\s\n\r\t]+|[\s\n\r\t]+$/g, '').replace(/\n/g, ' ').replace(/^(\s*-\s*)+/, ''),
                });
            });
        });
    }
    return approval;
}

export function keepFirstThreeOptions(stringData) {
    const optionsArray = stringData.split('\n');
    const firstThreeOptions = optionsArray.slice(0, 3);
    const result = firstThreeOptions.join('\n') + (optionsArray.length > 3 ? '#' : '');

    return result;
}

export function formatReqItemsPeriods(getApplication) {
    let reqItemsPeriods = '';
    const reqItemsDetails = getApplication.application.comp_leave_reqs.details;

    if (reqItemsDetails.length > 0) {
        for (let j = 0; j < reqItemsDetails.length; j++) {
            if (j > 2) {
                break;
            }
            const isSameDay = moment(reqItemsDetails[j].from).isSame(reqItemsDetails[j].to, 'day');
            const reqItemFrom = moment(reqItemsDetails[j].from).format(window.global.displayDateTimeFormat);
            const reqItemTo = moment(reqItemsDetails[j].to).format(isSameDay ? window.global.displayTimeFormat : window.global.displayDateTimeFormat);
            const reqItemsPeriod = `${j + 1}. ${reqItemFrom} - ${reqItemTo}` + (reqItemsDetails.length > 3 && j == 2 ? '#' : '\n');
            reqItemsPeriods += reqItemsPeriod;
        }
    }

    return reqItemsPeriods;
}